export enum ProcurementType {
  Public = 1,
  Private = 2
}

(ProcurementType as any).__typeName = 'ProcurementType';
